module.exports = __webpack_public_path__ + "src/assets/animations/echinacea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/echinacea.png
// module id = ./src/assets/animations/echinacea.png
// module chunks = 0